import { graphql, useStaticQuery } from 'gatsby';

const useAbout = () => {

    const data = useStaticQuery(graphql`
        query {
            allDatoCmsAbout {
                nodes {
                    nombre
                    email
                    edad
                    lugar
                    descripcion
                    subdescripcion
                }
            }
        }
    `);

    return data.allDatoCmsAbout.nodes[0];
}
 
export default useAbout;